import api from "../../axios";

export const getWeeklyPromotion = async () => {
    try {
        const response = await api.get(`/api/weekly-promotion?populate=*`);
        return response.data
    } catch (error) {
        console.error('Error fetching products:', error);
    }
}